export default "__VITE_ASSET__px7f$34K__"